import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M50 34c0-1.024-.39-2.047-1.172-2.828A3.99 3.99 0 0 0 46 30m0 16c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12q0 .821.108 1.614c.116.868.175 1.303.135 1.577-.04.286-.093.44-.234.693-.135.242-.374.48-.85.958l-10.222 10.22c-.346.347-.519.52-.642.721q-.165.271-.24.578c-.055.23-.055.475-.055.965V54.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C23.52 58 24.08 58 25.2 58H30v-4h4v-4h4l3.158-3.158c.477-.477.716-.716.958-.851.252-.141.407-.194.693-.234.275-.04.709.019 1.577.135Q45.179 46 46 46"
    />
  </svg>
);
export default SvgKey;
